import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotification } from 'shared/Notification';
import { MULTI_ACCOUNTS_NOTIFICATION_DURATION } from 'appConstants';
import { MultiAccountNotification } from 'components';

export default function useMultiAccountNotification(transNamespace) {
  const { notification } = useNotification();
  const { t } = useTranslation(transNamespace);

  const displayMultiAccountNotification = useCallback(
    (status: 'Off' | 'On', debtOwner: string = '') => {
      notification(
        <MultiAccountNotification
          title={t(`CustomerDetails.notifications.multi${status}${debtOwner}.title`)}
          description={t(`CustomerDetails.notifications.multi${status}${debtOwner}.description`)}
        />,
        'info',
        undefined,
        MULTI_ACCOUNTS_NOTIFICATION_DURATION,
      );
    },
    [notification, t],
  );

  return displayMultiAccountNotification;
}
